var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{class:_vm.className,attrs:{"id":_vm.id,"itemprop":_vm.itemProp},domProps:{"innerHTML":_vm._s(_vm.parsedLabel)}})}
var staticRenderFns = []

export { render, staticRenderFns }